module.exports = __webpack_public_path__ + "static/media/illustration-emotional-distress.eb05fae3.svg";